'use strict';

/* eslint-disable global-require */

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./index.prod');
} else {
  module.exports = require('./index.dev');
}


//////////////////
// WEBPACK FOOTER
// ../~/react-hot-loader/lib/index.js
// module id = 2091
// module chunks = 1